import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768; // px; per DESIGN.md §4.3 (Tablet ≥768, Desktop ≥1024)

/**
 * useIsMobile — viewport breakpoint hook.
 *
 * Mobile = < 768px. Tablet = 768-1023. Desktop = ≥1024.
 * Returns true only when below the tablet breakpoint.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < MOBILE_BREAKPOINT;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
